import createIcon from '../../createIcon';

/**
 * @component @name CreditScore
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgM0g0QzIuODkgMyAyLjAxIDMuODkgMi4wMSA1TDIgMTdDMiAxOC4xMSAyLjg5IDE5IDQgMTlIOVYxN0g0VjExSDIyVjVDMjIgMy44OSAyMS4xMSAzIDIwIDNaTTIwIDdINFY1SDIwVjdaTTE0LjkzIDE4LjE3TDEyLjEgMTUuMzRMMTAuNjkgMTYuNzVMMTQuOTMgMjFMMjIgMTMuOTNMMjAuNTkgMTIuNTJMMTQuOTMgMTguMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CreditScore = createIcon('CreditScore', [
  [
    'path',
    {
      d: 'M20 3H4C2.89 3 2.01 3.89 2.01 5L2 17C2 18.11 2.89 19 4 19H9V17H4V11H22V5C22 3.89 21.11 3 20 3ZM20 7H4V5H20V7ZM14.93 18.17L12.1 15.34L10.69 16.75L14.93 21L22 13.93L20.59 12.52L14.93 18.17Z',
      key: 'dekzaw',
    },
  ],
]);

export default CreditScore;
